// var flkty = new Flickity( '.carousel', {
//   on: {
//     ready: function() {
//       console.log('Flickity is ready');
//     },
//     change: function( index ) {
//       console.log( 'Slide changed to' + index );
//     }
//   }
// });


// var action="click";
// var speed="500";
// $('.faq__title').on(action, function() {
//    $('.faq__title').removeClass('active');
//       $(this).addClass('active');
//         // Get next element
//         $(this).next()
//             .slideToggle(speed)
//         // Select all other answers
//                 .siblings('.faq__content')
//                     .slideUp();
     
//     });

$(document).ready(function() {
    $Product_gridHtml =   $('.featured-collection__wrapper-products .product-grid').html();
    if($Product_gridHtml != undefined){
        $('.featured-collection__wrapper-products .product-grid').slick({
          infinite: false,
          speed: 300,
          slidesToShow: 4,
          slidesToScroll: 4,
          draggable: false,
          swipe: false,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
              }
            },
            {
              breakpoint: 749,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        });
    }
  $(".set > .faq__title").on("click", function() {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this).siblings(".faq__content").slideUp(200);
      // $(".set > a i").removeClass("fa-minus").addClass("fa-plus");
    } else {
      // $(".set > a i").removeClass("fa-minus").addClass("fa-plus");
      // $(this).find("i").removeClass("fa-plus").addClass("fa-minus");
      $(".set > .faq__title").removeClass("active");
      $(this).addClass("active");
      $(".faq__content").slideUp(200);
      $(this).siblings(".faq__content").slideDown(200);
      var store_this = $(this);
      setTimeout(function(){ 
        var $panel = store_this.closest('.set').offset().top - $('header').outerHeight();
        $('html,body').animate({
            scrollTop: $panel
        }, 500);  
      }, 200);
      
    }
  });

  document.querySelector('.upcart-header-close-button').addEventListener('click',function(){
    if(document.body.classList.contains('open-drawer-fixed')){
      document.body.classList.remove('open-drawer-fixed');    
    }
  })
});
